'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import BuildFutureFarming from '@/components/home/build-future-farming';
import BuildFutureFarmingImage from '@/components/home/build-future-farming-image';
import AgricultureNumbers from '@/components/home/agriculture-numbers';
import AgricultureSoftwareDevServices from '@/components/home/agriculture-softdev-service';
import AIEnabledAgriculture from '@/components/technologies/aienabled-agriculture-services';
import HireProcessAgricultureSoftware from '@/components/technologies/hire-process-agriculture-software';
import AgricultureCaseStudies from '@/components/home/agriculture-case-studies';
import AgricultureKeyFocus from '@/components/common/agriculture-key-focus';
import WhyChooseMowebAgriculture from '@/components/common/why-choose-moweb-agriculture';
import AgricultureFAQ from '@/components/faqs/agriculture-faq';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroAgricultureIndustry = dynamic(() => import('@/components/technologies/tech-hero-agriculture-industry'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroAgricultureIndustry />
            <BuildFutureFarming />
            <BuildFutureFarmingImage />
            <AgricultureNumbers />
            <AgricultureSoftwareDevServices />
            <AIEnabledAgriculture />
            <HireProcessAgricultureSoftware
                bg="bg-agriculture"
                white={true}
                pageTitle="Steps We Follow for Agriculture Software Development Services"
                desc="We ensure every custom fintech solution we build is secure, scalable, and built to deliver measurable results."
            />
            <AgricultureCaseStudies />
            <AgricultureKeyFocus />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <WhyChooseMowebAgriculture />
            <TechnologyFaq title="FAQs" bg="bg-aiml">
                <AgricultureFAQ />
            </TechnologyFaq>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
